import PerfectScrollbar from 'react-perfect-scrollbar';
import { useTranslation } from 'react-i18next';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Stack,
} from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import { convertTimestampToDate } from '@travelity/api/services';

import { User } from '@components/activity-history/components/user';
import {
    ActivityAction,
    supportedActions,
} from '@components/activity-history/components/activity-action';
import { DateTime } from '@components/activity-history/components/date-time';

import { capitalizeFirstLetter } from '@travelity/utils/strings';
import type { PackageSidebarItemsProps } from './types';

export const PackageActivities = ({ product }: PackageSidebarItemsProps) => {
    const { t } = useTranslation('product');

    const filteredLifecycle = product.lifecycle?.filter(activity =>
        supportedActions.includes(activity.type)
    );

    return (
        <Accordion disableGutters>
            <AccordionSummary>{t('Activity Log')}</AccordionSummary>
            <AccordionDetails>
                <PerfectScrollbar>
                    <Stack spacing={2} sx={{ width: '450px' }}>
                        {filteredLifecycle?.map(activity => (
                            <Stack
                                key={activity.at}
                                direction="row"
                                justifyContent="space-between"
                                sx={{
                                    color: '#6B748C',
                                    fontSize: '12px',
                                    textAlign: 'left',
                                }}
                            >
                                <Stack direction="row">
                                    <CircleIcon
                                        sx={{
                                            fontSize: '6px',
                                            color: '#6B748C',
                                            mr: 0.75,
                                            mt: 0.75,
                                        }}
                                    />
                                    <Box>
                                        <User name={activity.by.name} />{' '}
                                        <ActivityAction
                                            action={activity.type}
                                            entity="Package"
                                            updates={
                                                activity.updates
                                                    ?.filter(
                                                        ({ name }) => !!name
                                                    )
                                                    .map(({ name }) =>
                                                        name
                                                            .split('.')
                                                            .map(n =>
                                                                capitalizeFirstLetter(
                                                                    n.replaceAll(
                                                                        '_',
                                                                        ' '
                                                                    )
                                                                )
                                                            )
                                                            .join('➝')
                                                    ) || []
                                            }
                                        />
                                    </Box>
                                </Stack>
                                <DateTime
                                    date={convertTimestampToDate(activity.at)}
                                />
                            </Stack>
                        ))}
                    </Stack>
                </PerfectScrollbar>
            </AccordionDetails>
        </Accordion>
    );
};
